import { Box, LinearProgress, Stack, Typography } from '@mui/material';

import { getDomainBranding } from 'utils/domainBranding';

interface AppLoaderProps {
    message?: string;
    fullScreen?: boolean;
}

const AppLoader = ({ message, fullScreen = true }: AppLoaderProps) => {
    const branding = getDomainBranding();

    return (
        <Box
            role="status"
            aria-live="polite"
            aria-busy="true"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: fullScreen ? '100dvh' : undefined,
                height: fullScreen ? '100dvh' : undefined,
                bgcolor: fullScreen ? '#ffffff' : 'transparent',
                px: 2,
            }}
        >
            <Stack
                direction="column"
                spacing={3}
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    maxWidth: 360,
                }}
            >
                <Box
                    component="img"
                    src={branding.logo}
                    alt="Logo"
                    sx={{
                        width: branding.compactWidth,
                        maxWidth: '80vw',
                        height: 'auto',
                        objectFit: 'contain',
                    }}
                />
                <LinearProgress
                    sx={{
                        width: '100%',
                        maxWidth: 240,
                        height: 4,
                        borderRadius: 2,
                        bgcolor: 'rgba(96, 37, 216, 0.12)',
                        '& .MuiLinearProgress-bar': {
                            borderRadius: 2,
                            bgcolor: 'primary.main',
                        },
                    }}
                />
                {message && (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                        {message}
                    </Typography>
                )}
            </Stack>
        </Box>
    );
};

export default AppLoader;
